module.exports = __webpack_public_path__ + "static/media/jon-dollars.d0cec52e.md";